import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// import { fetchBalance } from './fetchBalanceServices';
// import { fetchTransactions } from './fetchCashTransactions';
// import TransactionRow from './components/transactionrow';
// import FormattedCurrencyNumber from '../../../FormattedCurrencyNumber';
import YearTransactionBlock from './components/yeartransactionblock';
import FilterPop from './components/filter-pop';
import LoadingState from '../common/loading-state/index';
import { getInstrumentedAxiosInstance } from '../../globs/ajax-proxy';
import config from '../../globs/config';
import gaPush from '../../globs/utils/google-analytics';

class Statment extends React.Component {
  static propTypes = {
    user: PropTypes.shape({}).isRequired,
  }
  state = {
    scrollTop: 0,
    isNavHidden: false,
    hasFinishedLoadingDayData: false,
    hasFinishedLoadingWeekData: false,
    hasTransitioned: false,
    transactionData: [],
    usr: null,
    ajaxloadingState: 'None',
    isDataLoading: true,
    filterOpen: false,
    selectedMonth: moment().month(),
    selectedYear: moment().year(),
    selectedType: ['ALL'],
    noDataForDuration: false,
    monthObj: {},
    newTransactionObj: {},
    currentSelectedMonth: moment().month(),
    currentSelectedYear: moment().year(),
    currentSelectedType: ['ALL'],
    isAppliedFilter: false,
    customerID: ''
  }
  componentDidMount() {
    const { props } = this;
    console.log('props inside comDidMount====>', props);
    let month = moment().month() + 1;
    console.log('month', month);
    month = String(month).length === 1 ? `0${month}` : month;
    setTimeout(() => {
      this.setState({
        hasTransitioned: true,
        usr: null,
        selectedMonth: month,
        currentSelectedMonth: month,
        customerID: this.props.match.params.customerId,
      }, () => {
        this.fetTransactions();
      });
    }, 100);
    // props.setIsNavVisible(true);
    // window.onpopstate = this.onBackButtonEvent;
  }

  onBackButtonEvent = (e) => {
    e.preventDefault();
    this.setState({
      filterOpen: false,
    });
    return false;
  }


  responseDelay = () => {
    setTimeout(() => {
      this.setState({
        noDataForDuration: false,
      });
    }, 5000);
  }

  fireGaEvent = (act, action, label) => {
    gaPush('event', {
      category: act,
      action,
      label,
    });
  };

  fetTransactions = () => {
    const { props, state } = this;
    const dateFrom1 = new Date(`${state.selectedYear}-${state.selectedMonth}-01`);
    const dateFrom2 = moment(dateFrom1).toISOString();
    const dateFrom = new Date(dateFrom2).toISOString().slice(0, 10);
    const lastDayOfMonth = new Date(state.selectedYear, Number(state.selectedMonth), 0).getDate();
    const dateTo1 = new Date(`${state.selectedYear}-${state.selectedMonth}-${lastDayOfMonth}`);
    const dateTo2 = moment(dateTo1).toISOString();
    const dateTo = new Date(dateTo2).toISOString().slice(0, 10);
    const typeArr = state.selectedType[0] === 'ALL' ? [] : state.selectedType;
    const duration = [dateFrom, dateTo];
    console.log(',,,,,,,,,', props, this.props.match);
    this.fireGaEvent('Payments and invoices', 'Load more', `Date from ${dateFrom} date to ${dateTo}`);
    const soId = props.user.id;
    const businessesId = this.props.match.params.customerId;
    // console.log('businessesId=======>', businessesId);
    const path_ = `${config.apiContextPath}/sales_officers/${soId}/businesses/${businessesId}/cash_transactions?type=${JSON.stringify(typeArr)}&date_from=${dateFrom}&date_to=${dateTo}&duration=${JSON.stringify(duration)}`;
    this.setState({
      isDataLoading: true,
      dateFrom,
      dateTo,
      // customerId: businessesId
    });

    getInstrumentedAxiosInstance().get(path_)
      .then((res) => {
        console.log(res);
        if (res.data.length === 0) {
          this.fireGaEvent('Payments and invoices', 'Payments and invoices', `No payments & invoices found between ${moment(this.state.dateFrom).format('DD.MM.YYYY')} and ${moment(this.state.dateTo).format('DD.MM.YYYY')}`);
        }
        const result = res.data;
        let monthObj = { ...state.monthObj };
        let newTransactionObj = { ...state.newTransactionObj };
        if (result.length > 0) {
          const transactionData = [...state.transactionData, ...result];
          if (state.selectedYear in newTransactionObj) {
            monthObj = {
              [state.selectedMonth]: [...result],
              ...state.monthObj,
            };
          } else {
            monthObj = {
              [state.selectedMonth]: [...result],
            };
          }
          if (!(state.selectedYear in newTransactionObj)) {
            newTransactionObj = {
              ...state.newTransactionObj,
              [state.selectedYear]: { [state.selectedMonth]: [...result] },
            };
          } else {
            newTransactionObj = {
              ...state.newTransactionObj,
              [state.selectedYear]: monthObj,
            };
          }
          this.setState({
            transactionData,
            isDataLoading: false,
            noDataForDuration: false,
            newTransactionObj,
            monthObj,
          });
        } else {
          this.setState({
            isDataLoading: false,
            noDataForDuration: true,
          }, () => {
            this.responseDelay();
          });
        }
      }).catch((error) => {
        this.setState({
          isDataLoading: false,
        });
        console.log('error in api====>', error);
      });
  }

  filterOpen = () => {
    this.setState({
      filterOpen: true,
    });
  }
  filterClose = () => {
    this.setState({
      filterOpen: false,
    });
  }
  fetchMoreData = () => {
    // this.fireGaEvnt('LoadMore');
    const { state } = this;
    let dateFrom = new Date(`${state.selectedYear}-${state.selectedMonth}-01`);
    dateFrom = moment(dateFrom).toISOString();
    let substractMonth = moment(new Date(`${dateFrom}`)).subtract(1, 'month').toISOString();
    let subMonth = new Date(substractMonth);
    subMonth = subMonth.getMonth() + 1;
    substractMonth = String(subMonth).length === 1 ? `0${subMonth}` : subMonth;
    const selectedMonth = substractMonth === 1 ? 12 : substractMonth;
    const selectedYear = subMonth === 12 ? state.selectedYear - 1 : state.selectedYear;
    this.setState({
      selectedMonth,
      selectedYear,
    }, () => {
      this.fetTransactions();
    });
  };

  applyFilter = (selectedMonth, selectedYear, selectedType, isAppliedFilter) => {
    this.setState({
      selectedMonth,
      selectedYear,
      selectedType,
      filterOpen: false,
      transactionData: [],
      newTransactionObj: {},
      isAppliedFilter,
    }, () => {
      this.fetTransactions();
    });
  }

  resetFilter = () => {
    const { props } = this;
    const selectedMonth = moment().month() + 1;
    const selectedYear = moment().year();
    const selectedType = ['ALL'];
    this.setState({
      selectedMonth,
      selectedYear,
      selectedType: [],
    }, () => {
      props.applyFilter(selectedMonth, selectedYear, selectedType);
    });
  }

  render() {
    const { props, state } = this;
    console.log('xxxx-xxxxxxx--', state);
    let isDataLoading;
    const classes = {
      view: classNames('lr-state-view lr-main-view', {
        'is-in-transition': !state.hasTransitioned,
      }),
      header: classNames('lr-main-view__header', {
        'is-nav-hidden': isDataLoading || state.isNavHidden,
      }),
    };
    return (
      <div className={classes.view} >
        <div className={classes.header}>
          <button
            type="button"
            onClick={() => props.history.goBack()}
            className="lr-main-view__header-title versementheader"
          >
            <i className="icon-back" />
            <div>Payments & Invoices</div>
          </button>
          {state.isDataLoading &&
            <div>
              <LoadingState />
              <div className="loadingContainer" />
            </div>
          }
          <button type="button" onClick={this.filterOpen} className={`icon-filter ${this.state.isAppliedFilter && (this.state.currentSelectedMonth !== this.state.selectedMonth || this.state.currentSelectedYear !== this.state.selectedYear || this.state.currentSelectedType[0] !== this.state.selectedType[0]) ? 'filter-active' : ''}`} />
          {/* <button type="button" onClick={this.filterOpen} className="font-icon-filter">
            <i className="icon-filter" />
          </button> */}
        </div>
        <div className="lr-statment lr-main-view__body">
          <div className="lr-statment-row-block">
            {
              Object.keys(state.newTransactionObj).sort().reverse().map(year => (
                <YearTransactionBlock
                  key={year}
                  year={year}
                  data={state.newTransactionObj[year]}
                  user={props.user}
                  customerID={state.customerID}
                />
              ))
            }
            <div className={`response-information ${state.noDataForDuration ? 'active' : ''}`}>
              <div className="flexbox">
                <span>No data found between</span>
                <span>{moment(state.dateFrom).format('DD.MM.YYYY')}</span>
                <span>and</span>
                <span>{moment(state.dateTo).format('DD.MM.YYYY')}</span>
              </div>
            </div>
            {
              !state.isDataLoading &&
              <div className="lr-orders__add-new-order">
                <button
                  className="lr-button lr-button--primary  lr-orders__add-new-order-button"
                  onClick={this.fetchMoreData}
                >
                  <span>Load More</span>
                </button>
              </div>
            }
          </div>
        </div>
        {
          state.filterOpen === true &&
          <FilterPop
            selectedMonth={state.selectedMonth}
            selectedYear={state.selectedYear}
            selectedType={state.selectedType}
            applyFilter={this.applyFilter}
            onBackButtonEvent={this.onBackButtonEvent}
            user={props.user}
          />
        }
      </div>
    );
  }
}


export default Statment;
